/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

export interface ProjectsFilesDownloadRetrieve$Params {
  file_id: number;
}

export function projectsFilesDownloadRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: ProjectsFilesDownloadRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, projectsFilesDownloadRetrieve.PATH, 'get');
  if (params) {
    rb.path('file_id', params.file_id, {});
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as BakendHttpResponse<void>;
    }),
  );
}

projectsFilesDownloadRetrieve.PATH = '/api/projects/files/{file_id}/download/';
